import { createContext } from 'react';

export type KeyboardNavigationConfig = Record<
  string,
  (event: KeyboardEvent) => void | Promise<void> | undefined
>;

export interface KeyboardEventOptions {
  isEnabled: boolean;
  preventDefault: boolean;
}

interface KeyboardNavigationContextValue {
  subscribe: (config: KeyboardNavigationConfig, options: Partial<KeyboardEventOptions>) => string;
  updateConfig: (
    id: string,
    config: KeyboardNavigationConfig,
    options: Partial<KeyboardEventOptions>
  ) => void;
  unsubscribe: (id: string) => void;
}

export const Context = createContext<KeyboardNavigationContextValue>({
  subscribe: () => '1',
  updateConfig: () => {},
  unsubscribe: () => {},
});
